import React, { useState } from 'react';
import { jsPDF } from 'jspdf';
import * as XLSX from 'xlsx';

const InfoModalCuerpo = ({ datos, sede }) => {
  const [verAsistencia, setVerAsistencia] = useState(true);
  const [verAusencias, setVerAusencias] = useState(true);
  const [verPases, setVerPases] = useState(true);
  const [verGuardia, setVerGuardia] = useState(true);

  const {
    promocion,
    FE,
    FP,
    FA,
    FF,
    Asistencia,
    Ausencia,
    Pases,
    Guardias
  } = datos;

  const fecha = new Date();

  const agruparPorCompania = (lista) => {
    return lista.reduce((acc, item) => {
      const compania = item.Compania;
      if (!acc[compania]) acc[compania] = [];
      acc[compania].push(item);
      return acc;
    }, {});
  };

  const asistenciasPorCompania = agruparPorCompania(Asistencia || []);
  const ausentesPorCompania = agruparPorCompania(Ausencia || []);
  const pasesPorCompania = agruparPorCompania(Pases || []);
  const guardiasPorCompania = agruparPorCompania(Guardias || []);

  const sortByApellido = (a, b) => {
    if (a.apellidoCadete < b.apellidoCadete) return -1;
    if (a.apellidoCadete > b.apellidoCadete) return 1;
    return 0;
  };

  // ---------------------- EXCEL ----------------------
  const limitarNombreHoja = (nombre) => {
    if (!nombre) return "Hoja";
    let limpio = nombre.replace(/[^A-Za-z0-9_]/g, "_");
    return limpio.substring(0, 31);
  };

  const exportarExcel = () => {
    const libro = XLSX.utils.book_new();

    const agregarSeccion = (objeto, titulo) => {
      Object.keys(objeto).forEach((compania) => {
        const data = objeto[compania].sort(sortByApellido);

        const rows = data.map((item, index) => ({
          N: index + 1,
          Apellido: item.apellidoCadete.toUpperCase(),
          Nombre: item.nombreCadete,
          DNI: item.cadeteDni,
          Seccion: item.Seccion || "",
          Tipo: item.Tipo ? item.Tipo[0] : ""
        }));

        const hoja = XLSX.utils.json_to_sheet(rows);

        XLSX.utils.book_append_sheet(
          libro,
          hoja,
          limitarNombreHoja(`${titulo}_${compania}`)
        );
      });
    };

    agregarSeccion(asistenciasPorCompania, "Asist");
    agregarSeccion(ausentesPorCompania, "Ausentes");
    agregarSeccion(pasesPorCompania, "Pases");
    agregarSeccion(guardiasPorCompania, "Guardias");

    XLSX.writeFile(
      libro,
      `Promocion_${promocion}_${fecha.toLocaleDateString()}.xlsx`
    );
  };

  // ---------------------- PDF ----------------------
  const exportarPDF = () => {
    const doc = new jsPDF();
    const pageHeight = doc.internal.pageSize.height;

    doc.setFontSize(18);
    doc.text(`Promoción ${promocion} (${sede})`, 20, 20);

    let yPosition = 30;

    const checkPageBreak = () => {
      if (yPosition > pageHeight - 20) {
        doc.addPage();
        yPosition = 20;
      }
    };

    if (FE || FP || FA || FF) {
      doc.setFontSize(12);
      doc.text(`FE: ${FE} | FP: ${FP} | FA: ${FA} | FF: ${FF}`, 10, yPosition);
      yPosition += 10;
    }

    const agregarSeccionPDF = (objeto, titulo) => {
      Object.keys(objeto).forEach((compania) => {
        doc.setFontSize(12);
        doc.text(`${titulo}: ${compania}`, 10, yPosition);
        yPosition += 5;

        const sorted = objeto[compania].sort(sortByApellido);

        sorted.forEach((cadete, index) => {
          checkPageBreak();
          doc.setFontSize(9);
          doc.text(
            `${index + 1}. ${cadete.apellidoCadete.toUpperCase()}, ${cadete.nombreCadete} - DNI: ${cadete.cadeteDni} ${cadete.Seccion || ""} ${cadete.Tipo ? "- Tipo: " + cadete.Tipo[0] : ""}`,
            20,
            yPosition
          );
          yPosition += 5;
        });
      });
    };

    agregarSeccionPDF(asistenciasPorCompania, "Asistencias");
    agregarSeccionPDF(ausentesPorCompania, "Cadetes Ausentes");
    agregarSeccionPDF(pasesPorCompania, "Pases de Salida");
    agregarSeccionPDF(guardiasPorCompania, "Guardias");

    doc.save(`Promocion_${promocion}_${fecha.toLocaleDateString()}.pdf`);
  };

  return (
    <>
      <h2>Promoción {promocion} ({sede}) ({fecha.toLocaleDateString()})</h2>

      {(FE || FP || FA || FF) && (
        <p>
          <strong>FE:</strong> {FE} | <strong>FP:</strong> {FP} | 
          <strong>FA:</strong> {FA} | <strong>FF:</strong> {FF}
        </p>
      )}

      {/* Secciones de vista desktop */}
      <div className="desktop-view">
        {/* ASISTENCIAS */}
        {Object.keys(asistenciasPorCompania).map((compania) => (
          <div key={compania}>
            <h4 style={{ color: "#889911" }} onClick={() => setVerAsistencia(!verAsistencia)}>
              Asistencias: {compania}
            </h4>

            {verAsistencia && (
              <ul>
                {asistenciasPorCompania[compania]
                  .sort(sortByApellido)
                  .map((asist, index) => (
                    <li key={index}>
                      <p>
                        {index + 1} <strong>{asist.apellidoCadete.toUpperCase()}, {asist.nombreCadete}</strong> -
                        DNI: {asist.cadeteDni} - {asist.Seccion}
                      </p>
                    </li>
                  ))}
              </ul>
            )}
          </div>
        ))}

        {/* AUSENTES */}
        {Object.keys(ausentesPorCompania).map((compania) => (
          <div key={compania}>
            <h4 style={{ color: "red" }} onClick={() => setVerAusencias(!verAusencias)}>
              Cadetes Ausentes: {compania}
            </h4>

            {verAusencias && (
              <ul>
                {ausentesPorCompania[compania]
                  .sort(sortByApellido)
                  .map((cadete, index) => (
                    <li key={index}>
                      <p>
                        {index + 1} <strong>{cadete.apellidoCadete.toUpperCase()}, {cadete.nombreCadete}</strong> -
                        DNI: {cadete.cadeteDni}
                      </p>
                    </li>
                  ))}
              </ul>
            )}
          </div>
        ))}

        {/* PASES */}
        {Object.keys(pasesPorCompania).map((compania) => (
          <div key={compania}>
            <h4 style={{ color: "blue" }} onClick={() => setVerPases(!verPases)}>
              Pases de Salida: {compania}
            </h4>

            {verPases && (
              <ul>
                {pasesPorCompania[compania]
                  .sort(sortByApellido)
                  .map((pase, index) => (
                    <li key={index}>
                      <p>
                        {index + 1} <strong>{pase.apellidoCadete.toUpperCase()}, {pase.nombreCadete}</strong> -
                        DNI: {pase.cadeteDni} - Tipo de Pase: {pase.Tipo[0]}
                      </p>
                    </li>
                  ))}
              </ul>
            )}
          </div>
        ))}

        {/* GUARDIAS */}
        {Object.keys(guardiasPorCompania).map((compania) => (
          <div key={compania}>
            <h4 style={{ color: "brown" }} onClick={() => setVerGuardia(!verGuardia)}>
              Guardias: {compania}
            </h4>

            {verGuardia && (
              <ul>
                {guardiasPorCompania[compania]
                  .sort(sortByApellido)
                  .map((guardia, index) => (
                    <li key={index}>
                      <p>
                        {index + 1} <strong>{guardia.apellidoCadete.toUpperCase()}, {guardia.nombreCadete}</strong> -
                        DNI: {guardia.cadeteDni} - Tipo de Guardia: {guardia.Tipo[0]}
                      </p>
                    </li>
                  ))}
              </ul>
            )}
          </div>
        ))}
      </div>

      {/* MOBILE */}
      <div className="mobile-view">
        <button className="btn btn-success" onClick={exportarPDF}>Descargar PDF</button>
        <button className="btn btn-primary mt-2" onClick={exportarExcel}>Descargar Excel</button>
      </div>

      {/* DESKTOP */}
      <div className="desktop-view">
        <button className="btn btn-success" onClick={exportarPDF}>Ver PDF</button>
        <button className="btn btn-primary ms-2" onClick={exportarExcel}>Descargar Excel</button>
      </div>

      <style>
        {`
          @media (max-width: 768px) {
            .desktop-view { display: none; }
            .mobile-view { display: block; text-align: center; }
          }

          @media (min-width: 769px) {
            .desktop-view { display: block; }
            .mobile-view  { display: none; }
          }
        `}
      </style>
    </>
  );
};

export default InfoModalCuerpo;
